export default "__VITE_ASSET__DeZoC0gv__"